
import { mapActions } from 'vuex'
export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      productQuantity: this.product.quantity,
    }
  },
  methods: {
    ...mapActions('cart', ['adicionarCart', 'deleteOneProduct']),
    actionDelete(value) {
      this.$emit('inputData', value)
    },
    incrementQuantityProduct(product) {
      this.adicionarCart(product)
      this.productQuantity++
    },
    decrementQuantityProduct(id) {
      this.deleteOneProduct(id)
      this.productQuantity--
    },
  },
}
